import { msg } from '@lingui/core/macro';

/** The read-only flag occupies bit 4 of the creator's channel layout. */
export const READONLY_BIT = 16;

export const READONLY_LABEL = {
  set_toast: msg`Channel set to read-only`,
  unset_toast: msg`Editing restored`,
  no_send_reject: msg`This channel is read-only. Only its creator can send messages.`,
};
